import styled from 'styled-components';
import { darkgrey, tabsBorder } from 'styles/Colors';
import { FontFamilyOswald } from 'styles/Fonts';

export const HeaderWrapper = styled.div`
  flex-shrink: 0;
  padding: 24px 32px;
  position: relative;
`;

export const Title = styled.div`
  ${FontFamilyOswald({ size: '22px' })}
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: ${darkgrey};
  width: calc(100% - 30px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CloseButton = styled.div`
  position: absolute;
  right: 24px;
  top: calc(50% - 16px);
  cursor: pointer;
`;

export const Separator = styled.hr`
  flex-shrink: 0;
  border: none;
  border-top: 1px solid ${tabsBorder};
  margin: 0;
`;
